import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import getDescription from '../../../utils/reducerUtils';
import {
  DataTextBold,
  OverviewInfoFieldDataValue,
  PaymentInfoFieldWrapper,
  SubsequentPremiumTermsConditions
} from '../../detailPageStyle';
import { LabelWrapper } from '../PolicyOverview/OverviewField';

const SubsequentPremiumField = (props, context) => {
  const { labelContent, fieldData, dependentFieldData } = props;
  const {
    intl: { locale }
  } = context;
  if (!labelContent || fieldData === 'N') {
    return <></>;
  }
  return (
    <PaymentInfoFieldWrapper id={labelContent}>
      <LabelWrapper {...props} />
      <OverviewInfoFieldDataValue>
        <DataTextBold>
          {getDescription(locale, dependentFieldData.narrative)}
        </DataTextBold>
      </OverviewInfoFieldDataValue>
      <SubsequentPremiumTermsConditions>
        <FormattedHTMLMessage id="premiumDiscountTermsAndCondition" />
      </SubsequentPremiumTermsConditions>
    </PaymentInfoFieldWrapper>
  );
};

SubsequentPremiumField.propTypes = {
  id: PropTypes.string.isRequired,
  labelContent: PropTypes.string.isRequired,
  fieldData: PropTypes.string.isRequired,
  dependentFieldData: PropTypes.string.isRequired
};

SubsequentPremiumField.contextTypes = {
  intl: PropTypes.object.isRequired
};

export default SubsequentPremiumField;
